import { ShiftStatusEnum } from '@umss/shared/utils';

export interface ShiftNeedRequestsSearchDto {
  status?: ShiftStatusEnum;
  initiated?: 'contractor' | 'facility';
  pageNumber?: number;
  pageSize?: number;
}
